var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStream({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#7292F7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_246_785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 15C21.1046 15 22 14.1046 22 13C22 11.8954 21.1046 11 20 11C18.8954 11 18 11.8954 18 13C18 14.1046 18.8954 15 20 15Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 15C5.10457 15 6 14.1046 6 13C6 11.8954 5.10457 11 4 11C2.89543 11 2 11.8954 2 13C2 14.1046 2.89543 15 4 15Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.88997 15.65L4.94997 18.58C4.55997 18.97 4.55997 19.6 4.94997 19.99C5.33997 20.38 5.96997 20.38 6.35997 19.99L9.29997 17.06C9.68997 16.68 9.68997 16.04 9.29997 15.65C8.90997 15.26 8.27997 15.26 7.88997 15.65Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41002 5.94002C6.02002 5.55002 5.39002 5.55002 5.00002 5.94002C4.61002 6.33002 4.61002 6.96002 5.00002 7.35002L7.93002 10.29C8.32002 10.68 8.95002 10.68 9.35002 10.29C9.73002 9.90002 9.73002 9.27002 9.34002 8.88002L6.41002 5.94002Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.12 15.65C15.73 15.26 15.1 15.26 14.7 15.65C14.31 16.04 14.31 16.67 14.7 17.06L17.64 20C18.03 20.39 18.66 20.39 19.05 20C19.44 19.61 19.44 18.98 19.05 18.59L16.12 15.65Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0599 10.33L19.0499 7.35001C19.4399 6.95001 19.4399 6.32001 19.0499 5.93001C18.6599 5.54001 18.0299 5.54001 17.6399 5.93001L14.6499 8.91001C14.2599 9.30001 14.2599 9.93001 14.6499 10.33C15.0399 10.72 15.6699 10.72 16.0599 10.33Z",
    fill: "inherit"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7Z",
    fill: "inherit"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_246_785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStream);
export default __webpack_public_path__ + "static/media/stream.85bf6d5b84da4550536bb4b8c3685ae2.svg";
export { ForwardRef as ReactComponent };